import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import ButtonCompo from "../../Components/ButtonComponent/ButtonCompo";
import APIServices from "../../services/APIServices";
import { useDispatch } from "react-redux";
import { setAccessToken, setRefreshToken, setLoginUserDetails } from "../../Redux/Actions";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function Login({ setLogin }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showLoader, setShowLoader] = useState(false);

    const [isValid, setIsValid] = useState(true);
    const handleChange = (e) => {
        setPassword(e.target.value);
        setPasswordError("");
    };
    const handleTogglePasswordVisibility = () => setShowPassword(!showPassword);
    useEffect(() => {
        if (typeof window !== "undefined") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, []);

    const refreshTokenExpirationDate = new Date();
    refreshTokenExpirationDate.setDate(refreshTokenExpirationDate.getDate() + 3);

    const validateEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    const validateDomain = (email) => /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email.split("@")[1]);
    const handleEmailChange = (e) => {
        const inputEmail = e.target.value;
        setEmail(inputEmail);
        setIsValid(validateEmail(inputEmail) && validateDomain(inputEmail));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (email && password) {
            setShowLoader(true);
            try {
                const response = await APIServices.login({ mail: email, password });
                console.log('response from login :', response.data);

                const token = response?.data?.token;
                const refreshToken = response?.data?.refreshToken;

                localStorage.setItem("isLoggedIn", true);
                localStorage.setItem("token", JSON.stringify(token));
                localStorage.setItem("refreshToken", JSON.stringify(refreshToken));
                localStorage.setItem("refreshTokenExpirationDate", JSON.stringify(refreshTokenExpirationDate));

                dispatch(setAccessToken(token));
                dispatch(setRefreshToken(refreshToken));
                dispatch(setLoginUserDetails(response?.data?.admin));
                setLogin(true);
                APIServices.setAuthToken(token);
                navigate('/customer', { replace: true });
            } catch (err) {
                console.error('Error during login:', err);
            } finally {
                setShowLoader(false);
            }
        } else if (!password) {
            setPasswordError("Please enter a password");
        }
    };

    return (
        <>
            <Backdrop
                sx={{
                    color: "#ffffff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={showLoader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <div className="bg-container">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-md-6 signup-left-container">
                            <h1 className="heading-login">Welcome back to Meetbytravel</h1>
                            <p style={{ color: "white" }}>
                                where your next group adventure awaits!
                            </p>

                            <p className="para">Manage your best travel experiences</p>
                        </div>
                        <div className="col-xs-12 col-md-6">

                            <div className="form-container">
                                <form className="form" onSubmit={handleSubmit}>
                                    <TextField
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-input": {
                                                fontFamily: "poppins",
                                                letterSpacing: "0.1px",
                                                fontSize: "13px",
                                            },
                                        }}
                                        placeholder="Email"
                                        type="email"
                                        value={email}
                                        onChange={handleEmailChange}
                                        required
                                        error={!isValid}
                                        helperText={
                                            !isValid ? "Please enter a valid email address" : ""
                                        }
                                        FormHelperTextProps={{ sx: { fontFamily: "Poppins" } }}
                                    />
                                    <TextField
                                        variant="outlined"
                                        sx={{
                                            "& .MuiInputBase-input": {
                                                fontFamily: "poppins",
                                                letterSpacing: "0.1px",
                                                fontSize: "13px",
                                            },
                                        }}
                                        placeholder="Password"
                                        size="small"
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={handleChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={handleTogglePasswordVisibility}
                                                        edge="end"
                                                    >
                                                        {showPassword ? (
                                                            <VisibilityOff />
                                                        ) : (
                                                            <Visibility />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        error={Boolean(passwordError)}
                                        helperText={passwordError}
                                        FormHelperTextProps={{ sx: { fontFamily: "Poppins" } }}
                                        InputLabelProps={{
                                            shrink: false,
                                        }}
                                    />


                                    <center>
                                        <ButtonCompo
                                            btnText="Log in"
                                            typeOfBtn="submit"
                                            disabledButton={
                                                email && password && isValid ? false : true
                                            }
                                        />{" "}
                                    </center>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default Login;

